import React, { useEffect, useState, useContext, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  GlobalStyles,
} from '@mui/material';

function ModalEditUserLimits() {
  const { t } = useTranslation();

  const {
    session,
    updateShowModalEditUserLimits,
    updateFocusOnMainScreen,
    userInfo,
    parentInfo,
    operator,
    hall,
    currentUser,
    userLimits,
    updateIsLoadingScreen,
    updateIsFullUserEditing,
  } = useContext(AppContext);

  const [limits, setLimits] = useState([]);

  const inputRefs = useRef([]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);
  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  useEffect(() => {
    updateIsLoadingScreen(true);
  }, []);

  useEffect(() => {
    socket.emit('checkAllUserLimits', {
      userID: !parentInfo ? userInfo.id : parentInfo.id,
    });
  }, [userInfo, parentInfo]);

  const [isUserConfirmed, setIsUserConfirmed] = useState('');
  // #region HANDLERS
  //* INPUT HANDLERS
  const [limitDaily, setLimitDaily] = useState('');
  const handleCashInChange = (event) => {
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    setLimitDaily(numericValue);

    //setLimitDaily(event.target.value);
  };
  const limitDailyRef = useRef(limitDaily);
  useEffect(() => {
    limitDailyRef.current = limitDaily;
  }, [limitDaily]);

  const [limitMonthly, setLimitMonthly] = useState('');
  const handleCashOutChange = (event) => {
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    setLimitMonthly(numericValue);
  };
  const limitMonthlyRef = useRef(limitMonthly);
  useEffect(() => {
    limitMonthlyRef.current = limitMonthly;
  }, [limitMonthly]);

  useEffect(() => {
    setLimitDaily(userLimits.limitDaily);
    setLimitMonthly(userLimits.limitMonthly);
  }, [userLimits]);

  const inputRef = useRef(null);

  useEffect(() => {
    updateFocusOnMainScreen(false);

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 600);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // #region SOCKETS
  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleUpdateUserLimits = (data) => {
      if (!data) {
        updateIsLoadingScreen(false);
        toast.error(t('error.error'));
        return;
      }

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      } else {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      updateIsLoadingScreen(false);
      setIsUserConfirmed(true);
    };

    const handleCheckAllUserLimits = (data) => {
      setLimits(data);
      updateIsLoadingScreen(false);
    };

    socket.on('updateUserLimits', handleUpdateUserLimits);
    socket.on('checkAllUserLimits', handleCheckAllUserLimits);

    return () => {
      socket.off('checkAllUserLimits', handleCheckAllUserLimits);
      socket.off('updateUserLimits', handleUpdateUserLimits);
    };
  }, [socket]);

  // #region LOGIC
  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const handleConfirm = async () => {
    updateIsLoadingScreen(true);

    socket.emit('updateUserLimits', {
      userID: parentInfoRef.current
        ? parentInfoRef.current.id
        : userInfoRef.current.id,
      limits: limits,
      action: 'updateUserLimits',
    });
  };

  //* CANCEL BUTTON (close the modal and go back to main screen)
  const handleCancel = () => {
    //updateFocusOnMainScreen(true);
    updateIsFullUserEditing(true);
    updateShowModalEditUserLimits(false);
    updateIsLoadingScreen(false);
  };

  const handleChange = (index, field) => (e) => {
    const value = e.target.value.replace(/\D/g, ''); // simple “digits-only” guard
    setLimits((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  return (
    <>
      {limits.length > 0 && (
        <div id="react-confirm-alert">
          <div class="react-confirm-alert-overlay">
            <div class="react-confirm-alert">
              {isUserConfirmed ? (
                <div
                  className="react-confirm-alert-body"
                  style={{ width: '1000px' }}
                >
                  <h1>{t('sales.limitsUpdated')}</h1>

                  <div className="react-confirm-alert-button-group">
                    <button
                      className="btn-custom-yes"
                      onClick={() => {
                        handleCancel();
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px', // Space between icon and text
                      }}
                    >
                      <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                      {t('sales.confirm')}
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <GlobalStyles
                    styles={{
                      '.react-confirm-alert-overlay': {
                        background: 'rgba(255,255,255,0.8)',
                      },
                      '.react-confirm-alert-body': {
                        padding: '1.5rem 2rem',
                        borderRadius: 12,
                      },
                    }}
                  />

                  <Box
                    className="react-confirm-alert-body"
                    sx={{
                      width: 1200,
                      overflowY: 'auto',
                      bgcolor: '#232a45',
                    }}
                  >
                    <Typography variant="h5" gutterBottom>
                      {parentInfo
                        ? `${parentInfo.firstname} ${parentInfo.lastname}`
                        : `${userInfo.firstname} ${userInfo.lastname}`}
                      {t('header.userLimitsMenuTitle')}
                    </Typography>

                    {limits.length > 0 && (
                      <Grid container spacing={1.5}>
                        {limits.map((bingo, i) => (
                          <Grid item xs={12} md={6} key={bingo.bingoName}>
                            <Paper
                              variant="outlined"
                              sx={{ p: 0.5, borderRadius: 2 }}
                              style={{
                                color: 'white',
                                backgroundColor: '#232a45',
                              }}
                            >
                              <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
                                {bingo.bingoName}
                              </Typography>

                              <TextField
                                label={t('sales.limitDaily')}
                                margin="dense"
                                fullWidth
                                autoComplete="off"
                                value={bingo.limitDaily}
                                onChange={handleChange(i, 'limitDaily')}
                                inputRef={(el) => (inputRefs.current[i] = el)}
                                className="modal-textfield"
                              />
                              <TextField
                                label={t('sales.limitMonthly')}
                                margin="dense"
                                fullWidth
                                autoComplete="off"
                                value={bingo.limitMonthly}
                                onChange={handleChange(i, 'limitMonthly')}
                                className="modal-textfield"
                              />
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    )}

                    <Box
                      className="react-confirm-alert-button-group"
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 2,
                        mt: 2,
                      }}
                    >
                      <Button
                        onClick={() => {
                          handleConfirm();
                        }}
                        className="btn-custom-yes"
                        sx={{ textTransform: 'none' }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px', // Space between icon and text
                        }}
                      >
                        <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                        {t('sales.confirm')}
                      </Button>
                      <Button
                        onClick={() => {
                          handleCancel();
                        }}
                        sx={{ textTransform: 'none' }}
                        className="btn-custom-no"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px', // Space between icon and text
                        }}
                      >
                        <CancelIcon style={{ fontSize: '1.2em' }} />
                        {t('sales.cancel')}
                      </Button>
                    </Box>
                  </Box>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ModalEditUserLimits;
